import { Link } from 'gatsby'
import React from 'react'

const footerLinks = [
  {
    name: 'Home',
    url: '/',
  },
  {
    name: 'Shop',
    url: 'https://shop.bluerondogames.com',
    external: true,
  },
  {
    name: 'Contact',
    url: 'mailto:rick@bluerondogames.com',
  },
  {
    name: 'Joker Crabs',
    url: '/crabs/imitation_crab',
  },
  {
    name: 'Team',
    url: 'https://bluerondogames.com/about',
    external: true,
  },
  {
    name: 'Blue Rondo Games',
    url: 'https://bluerondogames.com/',
    external: true,
  },
]

const Footer = () => (
  <footer className="
    bg-ocean-floor
  ">
    <div className="
      py-6
      grid
      grid-cols-3
      gap-4
      leading-5
      text-sm
      mx-auto
      w-[90%]
      max-w-md
      md:max-w-lg
    ">
      {footerLinks.map(item => (
        <div className="
          text-ocean-foam
          hover:underline
        ">
          {item.external ?
            <a
              href={item.url}
              target='_blank'
              rel="noreferrer"
            >
              {item.name}
            </a>
          :
            <Link
              to={item.url}
            >
              {item.name}
            </Link>
          }
        </div>
      ))}
    </div>
    <p className="
      text-ocean-foam
      pb-2
      text-center
      text-sm
    ">
      © Blue Rondo Games 2025
    </p>
  </footer>
)

export default Footer
